import React from "react";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EstablishmentValencesCard } from "./establishment_valences_card.component";
import { EstablishmentFilterForm } from "../forms/establishment-filter.form";
import debounce from "lodash-es/debounce";
import isEqual from "lodash-es/isEqual";
import { Api } from "../../utils/api";
import { CountyView } from "./county_view.component";
import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import ConfirmInputDialog from "../../components/confirm-input.component";
import AlertDialog from "../../components/alert.component";
import CircularProgress from "@material-ui/core/CircularProgress";
import ConfirmDialog from "../../components/confirm.component";

export class EstablishmentFilterCard extends React.Component {
  state = {
    selectableEstablishments: null,
    searchValues: {},
    showConfirm: false,
    establishmentId: -1,
    establishmentName: "",
    establishmentGps: "",
    confirmInputMessage: "",
    showAlert: false,
    canAutoSelectEstablishments: false,
    isNameFilterEnabled: false,
    showError: false,
    visitTime: null,
    admissionDate: null,
    monthlyPayment: null,
  };

  constructor() {
    super();
    this.api = new Api();
    this.form = null;
    this.handleChange = debounce(this.handleChange.bind(this), 250, {
      loading: true,
    });
    this.addEstablishmentRequest = this.addEstablishmentRequest.bind(this);
    this.setForm = this.setForm.bind(this);
    this.submit = this.submit.bind(this);
    this.isSubmitting = this.isSubmitting.bind(this);
    this.showConfirm = this.showConfirm.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
    this.setNote = this.setNote.bind(this);
    this.showAlert = this.showAlert.bind(this);
    this.closeAlert = this.closeAlert.bind(this);
    this.enableNameFilter = this.enableNameFilter.bind(this);
    this.showError = this.showError.bind(this);
    this.closeError = this.closeError.bind(this);
  }

  oldValues = null;
  mapOldValues = null;
  searchTimes = 0;

  findEstablishments(searchValues, force = false) {
    const { map_radius, map_latitude, map_longitude, ...filters } =
      searchValues;

    const mapFilters = {
      map_radius,
      map_latitude,
      map_longitude,
    };

    if (isEqual(filters, this.oldValues || {}) && !force) {
      if (!isEqual(mapFilters, this.mapOldValues || {}) && !force) {
        this.mapOldValues = mapFilters;
        this.setState({ searchValues });
        return;
      }
      return;
    }

    this.setState({ searchValues });
    this.mapOldValues = mapFilters;
    this.oldValues = filters;
    const { id } = this.props.request;
    const searchScope = id ? { user_request_scope: id } : {};

    /** requirements from establishments auto selection */
    //
    this.setState({ selectableEstablishments: [] });
    if (!filters.options_filter && !filters.map_filter && !filters.name_filter)
      return;
    //
    if (
      filters.options_filter &&
      (!filters.proposed_price ||
        !filters.valence_id ||
        !filters.min_price ||
        !filters.max_price)
    )
      return;
    //
    //
    if (this.searchTimes > 1)
      this.setState({ canAutoSelectEstablishments: true });

    this.setState({
      selectableEstablishments: [],
      canAutoSelectEstablishments: filters.options_filter,
    });
    //
    /** */
    this.api
      .get("/establishment_valences", {
        ...filters,
        ...searchScope,
      })
      .then(({ data: selectableEstablishments = [] }) => {
        this.setState({ selectableEstablishments, searchValues });
        this.searchTimes++;
      });
  }

  async addEstablishmentRequest(
    establishment_valence_id,
    establishment_name = "",
    auto_selected = true,
    show_confirm = false,
    gps_dist
  ) {
    let origin_search =
      this.state.searchValues.name_filter === true
        ? "name"
        : this.state.searchValues.map_filter === true
        ? "map"
        : "selection";
    if (show_confirm) {
      let gps = [];
      for (let e of this.state.selectableEstablishments) {
        if (e.id === establishment_valence_id) {
          gps.push(e.gps_dist);
        }
      }
      this.showConfirm(establishment_valence_id, establishment_name, gps);
    } else {
      const { id } = this.props.request;
      try {
        await this.api.post(`user_requests/${id}/establishment_requests`, {
          establishment_valence_id,
          auto_selected,
          visit_time: this.state.visitTime,
          admission_date: this.state.admissionDate,
          monthly_payment: this.state.monthlyPayment,
          monthly_payment_initial: this.state.monthlyPayment,
          origin_search,
          gps_dist: parseFloat(gps_dist),
          message_professional: this.props.messageTextFromStats(),
        });
      } catch {
        console.error(
          "error adding establishment with id: " + establishment_valence_id
        );
      } finally {
        this.props.refreshEstablishments().then(() => {
          this.findEstablishments(
            { ...this.oldValues, ...this.mapOldValues },
            true
          );
        });
      }
    }
  }

  async updateUsersRequest() {
    await this.api.patch(`user_requests/${this.props.request.id}`, {
      proposed_visit_time: this.state.visitTime,
      proposed_admission_date: this.state.admissionDate,
      proposed_price: this.state.monthlyPayment,
      min_price: this.state.monthlyPayment - 100,
      max_price: this.state.monthlyPayment + 100,
    });
  }

  handleSubmit = async (params) => {
    if (!this.props.request.closest_parish) return this.showError();

    let autoAddedEstablishments = this.state.canAutoSelectEstablishments
      ? 0
      : this.props.establishmentRequests.filter((e) => e.auto_selected).length;
    //
    //update hi_users_requests
    await this.updateUsersRequest();
    //
    for (var e of this.state.selectableEstablishments) {
      const no_access_to_req = e.disable_access_to_requests;
      const force_requests = e.force_requests;
      const gps_dist = e.gps_dist;
      if (force_requests || no_access_to_req)
        await this.addEstablishmentRequest(e.id, "", true, false, gps_dist);
      else if (autoAddedEstablishments < 3) {
        //TODO: check if this method returns an error and proceeed to the next establishment..
        await this.addEstablishmentRequest(e.id, "", true, false, gps_dist);
        autoAddedEstablishments = autoAddedEstablishments + 1;
      } else break;
    }
    //
    this.props.handleSubmit(params).then(() => {
      const { request_type } = this.props.request;
      return request_type === "Disperso"
        ? this.props.refreshEstablishments()
        : Promise.resolve();
    });
  };

  componentDidMount() {
    const {
      min_price,
      max_price,
      search_all_counties,
      search_closest_counties,
      search_closest_parishes,
      valence_id,
      proposed_price,
    } = this.props.request;
    this.findEstablishments({
      min_price,
      max_price,
      search_all_counties,
      search_closest_counties,
      search_closest_parishes,
      valence_id,
      proposed_price,
    });
  }

  selectToString(value) {
    return typeof value === "string"
      ? value
      : value.map((res) => res.value).join(",");
  }

  handleChange(values) {
    this.findEstablishments({
      ...values,
    });
    this.setState({ visitTime: values.proposed_visit_time });
    this.setState({ admissionDate: values.proposed_admission_date });
    this.setState({ monthlyPayment: values.proposed_price });
  }

  setForm(form) {
    this.form = form;
  }

  submit() {
    if (this.form) {
      this.form.submitForm();
    }
  }

  isSubmitting() {
    return this.form ? this.form.isSubmitting : false;
  }

  showConfirm(eId, eName, eGps) {
    this.setState({
      showConfirm: true,
      establishmentId: eId,
      establishmentName: eName,
      establishmentGps: eGps,
    });
  }

  closeConfirm() {
    this.setState({ showConfirm: false });
  }

  setNote(v) {
    this.setState({ confirmInputMessage: v });
    this.closeConfirm();
    if (v && (v !== "" || v !== null)) {
      this.api
        .post(`/notes`, {
          note: {
            context_type: "UserRequest",
            context_id: this.props.request.id,
            note: `Justificação do encaminhamento para '${this.state.establishmentName}': ${v}`,
          },
        })
        .then(() => {
          //update hi_users_requests
          this.updateUsersRequest()
            //create hi_establishments_requests
            .then(() => {
              this.addEstablishmentRequest(
                this.state.establishmentId,
                this.state.establishmentName,
                false,
                false,
                this.state.establishmentGps
              );
            })
            .then(() => {
              this.showAlert();
            })
            .catch(() => {});
        })
        .catch(() => {});
    }
  }

  showAlert() {
    this.setState({ showAlert: true });
  }

  showError() {
    this.setState({ showError: true });
  }

  closeAlert() {
    this.setState({ showAlert: false });
  }

  closeError() {
    this.setState({ showError: false });
  }

  enableNameFilter(b) {
    this.setState({ isNameFilterEnabled: b });
  }

  render() {
    const request = this.props.request;
    const { search_closest_counties, search_all_counties } = request;
    const counties_string = [
      search_closest_counties,
      search_all_counties,
    ].join();
    const counties_list = Array.from(
      new Set(counties_string.split(","))
    ).filter((elem) => elem && elem.length > 0);
    const { map_radius, map_latitude, map_longitude, proposed_price } =
      this.state.searchValues || {};
    //console.log( { map_radius, map_latitude, map_longitude } );
    //console.log(this.state.searchValues.name_filter, this.state.searchValues.map_filter);

    //nr de pedidos nao enviados
    let requests_not_sent_yet = this.props.establishmentRequests.filter(
      (er) => !er.sent_at
    ).length;

    //conta tds equipamentos adicionados automaticamente, estejam enviados ou nao
    let countAllAutoAddedEstablishments = this.props.establishmentRequests
      ? this.props.establishmentRequests.filter((e) => e.auto_selected).length
      : 0;

    //conta tds equipamentos adicionados automaticamente que nao estao enviados
    let countAutoNotSentEstablishments = this.props.establishmentRequests
      ? this.props.establishmentRequests.filter(
          (e) => e.auto_selected && !e.sent_at
        ).length
      : 0;

    //conta tds equipamentos adicionados manualmente, estejam ou nao enviados
    let countManualAddedEstablishments = this.props.establishmentRequests
      ? this.props.establishmentRequests.filter((e) => !e.auto_selected).length
      : 0;

    //conta tds equipamentos adicionados manualmente e que ainda não foram enviados
    let countManualNotSentEstablishments = this.props.establishmentRequests
      ? this.props.establishmentRequests.filter(
          (e) => !e.auto_selected && !e.sent_at
        ).length
      : 0;

    return (
      <>
        <Typography gutterBottom variant="title" className="equipamentos-title">
          Equipamentos
        </Typography>

        <ExpansionPanel square>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <Grid container alignItems="center">
              <Grid item md={1}>
                <Tooltip title="Mensalidade Procurada">
                  <Typography className="signs-span" variant="body2">
                    <FontAwesomeIcon icon="euro-sign" />
                    {!!request.proposed_price && request.proposed_price}
                  </Typography>
                </Tooltip>
              </Grid>
              <Grid item md={1} />

              <Grid item md={3}>
                <Typography variant="body2">
                  {request.valence && request.valence.name}
                </Typography>
              </Grid>
              <Grid item md={2} />
              <Grid item md={5}>
                {false &&
                  search_closest_counties &&
                  counties_list.map((county, index) => {
                    return (
                      <CountyView
                        key={county}
                        id={county}
                        comma={counties_list.length - 1 === index ? "" : ", "}
                      />
                    );
                  })}
              </Grid>
            </Grid>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid container>
              <Grid item md={3}>
                <EstablishmentFilterForm
                  onSubmit={this.handleSubmit}
                  onChange={this.handleChange}
                  getForm={this.setForm}
                  establishments={this.state.selectableEstablishments}
                  {...this.props.request}
                  map_radius={map_radius}
                  map_latitude={map_latitude}
                  map_longitude={map_longitude}
                  addEstablishmentValence={this.addEstablishmentRequest}
                  countAllAutoAddedEstablishments={
                    countAllAutoAddedEstablishments
                  }
                  countManualAddedEstablishments={
                    countManualAddedEstablishments
                  }
                  countManualNotSentEstablishments={
                    countManualNotSentEstablishments
                  }
                  enableNameFilter={this.enableNameFilter}
                  visitTime={this.state.visitTime}
                  admissionDate={this.state.admissionDate}
                  monthlyPayment={this.state.monthlyPayment}
                />
              </Grid>
              <Grid item md={9}>
                {/*render of establishments  after filter*/}
                {this.state.selectableEstablishments === null && (
                  <CircularProgress color="primary" />
                )}
                {this.state.selectableEstablishments && (
                  <EstablishmentValencesCard
                    userRequest={this.props.request}
                    establishmentValences={this.state.selectableEstablishments}
                    disperseRequest={request.request_type === "Disperso"}
                    addEstablishmentValence={this.addEstablishmentRequest}
                    visitTime={this.state.visitTime}
                    admissionDate={this.state.admissionDate}
                    monthlyPayment={this.state.monthlyPayment}
                    filters={this.state.searchValues}
                    localidade_parish={request.closest_parish}
                    localidade_county={request.closest_county}
                    nrAutoAddedEstablishments={
                      this.state.canAutoSelectEstablishments
                        ? 0
                        : this.props.establishmentRequests
                        ? this.props.establishmentRequests.filter(
                            (e) => e.auto_selected
                          ).length
                        : 0
                    }
                    //conta tds equipamentos adicionados automaticamente, estejam enviados ou nao
                    countAllAutoAddedEstablishments={
                      countAllAutoAddedEstablishments
                    }
                    //conta tds equipamentos adicionados automaticamente que nao estao enviados
                    countAutoNotSentEstablishments={
                      countAutoNotSentEstablishments
                    }
                    //conta tds equipamentos adicionados manualmente, estejam ou nao enviados
                    countManualAddedEstablishments={
                      countManualAddedEstablishments
                    }
                    countManualNotSentEstablishments={
                      countManualNotSentEstablishments
                    }
                    isNameFilterEnabled={this.state.isNameFilterEnabled}
                  />
                )}
              </Grid>
            </Grid>
          </ExpansionPanelDetails>
          <Divider />
          <ExpansionPanelActions>
            <div class={requests_not_sent_yet > 0 ? "" : "d-none"}>
              <Button disabled size="small" color="primary">
                {this.state.canAutoSelectEstablishments &&
                request.message_from_stats === null
                  ? "Guardar Seleção Automática"
                  : "Salvar"}
              </Button>
            </div>
            <div class={requests_not_sent_yet > 0 ? "d-none" : ""}>
              {proposed_price !== 1 && (
                <Button onClick={this.submit} size="small" color="primary">
                  {this.state.canAutoSelectEstablishments &&
                  request.message_from_stats !== null
                    ? "Guardar Seleção Automática"
                    : ""}
                </Button>
              )}
            </div>
          </ExpansionPanelActions>
        </ExpansionPanel>
        <ConfirmInputDialog
          open={this.state.showConfirm}
          title={"Obrigatório"}
          message={
            "Indicar pf. o motivo para adicionar manualmente o equipamento:"
          }
          handleOk={this.setNote}
          handleCancel={this.closeConfirm}
          required
        />
        <ConfirmDialog
          open={this.state.showConfirmToAdd}
          title={"Atenção"}
          message={
            "Pretende prosseguir com a selecção automática dos equipamentos?"
          }
          handleOk={this.setNote}
          handleCancel={this.closeConfirm}
        />
        <AlertDialog
          open={this.state.showAlert}
          handleClose={this.closeAlert}
          title={"Sucesso"}
          message={"Equipamento adicionado com sucesso!"}
        ></AlertDialog>
        <AlertDialog
          open={this.state.showError}
          handleClose={this.closeError}
          title={"Erro"}
          message={"Por favor preencha todos os dados obrigatórios do pedido"}
        ></AlertDialog>
      </>
    );
  }
}
